<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">
  <div class="timeline-body">
    <trumbowyg [initialContent]="descricaoRealidade.descricaoRealidade" [options]="options1" [update]="update$"
      (savedContent)="descricaoRealidade.descricaoRealidade=$event">
    </trumbowyg>
  </div>
  <div class="timeline-footer">
    <a class="btn btn-primary btn-sm" (click)="modificaDescricaoRealidade()">Realizar ajuste</a>
  </div>
</div>